import VinSearch from './vinSearch'
import ChooseVehicle from './chooseVehicle'
import { configSelectors } from '@/store/configs'
import { i18nL10nSelectors } from '@/store/i18nL10n'
import { productSelectors } from '@/store/products'
import { useSelector } from 'react-redux'
import { ContentContainer } from '@/components/styles'
import ContentHeader from '../shared/contentHeader'
import { i18nConstants, generalConstants } from '@tweddle-se-team/common/constants'

const { rtlLanguagesISO2Codes } = i18nConstants
const { BRANDS } = generalConstants

const Content = () => {
  const products = useSelector(productSelectors.selectProducts)
  const i18nL10n = useSelector(i18nL10nSelectors.selectI18nL10n)
  const modelLangMarketingNames = useSelector(configSelectors.selectConfigByKey('modelLangMarketingNames'))
  const { locale } = i18nL10n
  const {
    filterBy: { brand }
  } = products
  const isLexus = brand.toLowerCase() === BRANDS.LEXUS
  const rightAlign = Array.isArray(rtlLanguagesISO2Codes) && locale ? rtlLanguagesISO2Codes.includes(locale) : false

  return (
    <div>
      <ContentContainer $rightAlign={rightAlign}>
        <ContentHeader brand paragraph divider={!isLexus} rtl={rightAlign} useHeaderTag />
      </ContentContainer>
      <ContentContainer $rightAlign={rightAlign}>
        <VinSearch i18nL10n={i18nL10n} products={products} />
        <ChooseVehicle i18nL10n={i18nL10n} products={products} modelLangMarketingNames={modelLangMarketingNames} />
        <div className="mb-30" />
      </ContentContainer>
    </div>
  )
}

export default Content
